//@flow

import styled from "styled-components"
import * as BaseUI from "../UI"

export const TitleText = BaseUI.TitleText

export const TitleDescription = BaseUI.TitleDescription

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: #a5d9f2;
`

export const Titles = styled.div`
  position: absolute;
  top: 104px;
  left: 104px;
  width: 700px;
  z-index: 3;
  padding: 2rem;
`

export const Foreground = styled.div`
  position: absolute;
  bottom: 40px;
  right: 300px;
  height: 626px;
  width: 742px;
  z-index: 2;
`

export const Midground = styled.div`
  position: absolute;
  bottom: -20px;
  left: -100px;
  height: 441px;
  width: 2056px;
  z-index: 1;
`

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: -50px;
  height: 616px;
  width: 2047px;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Bike/UI.js